<div class="welcome-page-content">
  @if(welcomeDialog === 'welcome-login') {
  <div class="welcome-button-container">
    <a class="small-button" href="login">Welcome! Click here to log in.</a>
  </div>
  }
  @if (welcomeDialog === 'welcome-dashboard') {
  <div class="welcome-button-container">
    <a class="small-button" href="">Welcome! Click here to view your dashboard.</a>
  </div>
  }
</div>